import { Button } from "../../../_helpers/components/Button";
import { Toggle } from "../../../_helpers/components/Forms/ToggleButton";
import { DefaultDropdown } from "../../../_helpers/components/Forms/Dropdown";

export const InterventionsPlanificationModal = (props) => {
    let {
        title,
        handleSave,
        setVisible,
        loading,
        dateInput,
        hourInput,
        durationInput,
        remarksInput,
        duplicateInput,
        usersCanEnroll,
        statusInput,
    } = props;
    
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50" onClick={() => setVisible(false)}>
            <div className="bg-white lg:rounded-2xl shadow-lg w-full lg:max-w-md h-full lg:h-auto p-6 h-max-content overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-xl font-semibold mb-4">
                    {title}
                </h2>
                <div className="space-y-3">
                    {!(dateInput === undefined) &&
                        <div>
                            {!(dateInput.setValue === null) &&
                                <>
                                    <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">{dateInput.label}{dateInput.isRequired && <span className="text-red-600"> *</span>}</label>
                                    <input
                                        type="date"
                                        className="w-full bg-gray-200 border rounded px-3 py-2"
                                        value={dateInput.value}
                                        onChange={(e) => dateInput.setValue(e.target.value)}
                                        required={dateInput.isRequired}
                                    /></>
                            }
                            {dateInput.setValue === null &&
                                <p className="text-sm text-gray-500 mb-4">
                                    Pour le <strong>{new Date(dateInput.value).toLocaleDateString()}</strong>
                                </p>
                            }
                        </div>
                    }
                    {!(hourInput === undefined) &&
                        < div >
                            <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">{hourInput.label}{hourInput.isRequired && <span className="text-red-600"> *</span>}</label>
                            <input
                                type="time"
                                className="w-full bg-gray-200 border rounded px-3 py-2"
                                value={hourInput.value}
                                onChange={(e) => hourInput.setValue(e.target.value)}
                                required={hourInput.isRequired}
                            />
                        </div>
                    }
                    {!(durationInput === undefined) &&
                        <div>
                            <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">{durationInput.label}{durationInput.isRequired && <span className="text-red-600"> *</span>}</label>
                            <input
                                type="time"
                                className="w-full bg-gray-200 border rounded px-3 py-2"
                                value={durationInput.value}
                                onChange={(e) => durationInput.setValue(e.target.value)}
                                required={durationInput.isRequired}
                            />
                        </div>
                    }

                    {usersCanEnroll !== undefined &&
                        <DefaultDropdown
                            key={"performer"}
                            name={"Assignée à"}
                            options={[{ label: "", value: null }, ...usersCanEnroll.options.map(u => ({ label: (u.last_name ?? "") + " " + (u.first_name ?? ""), value: u.id }))]}
                            value={usersCanEnroll.value}
                            onChange={(e) => usersCanEnroll.setValue(e.target.value)}
                        />
                    }

                    {statusInput !== undefined &&
                        <DefaultDropdown
                            key={"status"}
                            name={"Etat"}
                            options={[...statusInput.options.map(s => ({ label: s.label, value: s.value }))]}
                            value={statusInput.value}
                            onChange={(e) => statusInput.setValue(e.target.value)}
                        />
                    }

                    {!(remarksInput === undefined) &&
                        <div>
                            <label className="text-left block uppercase tracking-wide text-app-primary text-xs font-bold mb-2">{remarksInput.label}{remarksInput.isRequired && <span className="text-red-600"> *</span>}</label>
                            <textarea
                                name="remarks"
                                value={remarksInput.value}
                                onChange={(e) => remarksInput.setValue(e.target.value)}
                                className="w-full bg-gray-200 border rounded px-3 py-2"
                                rows="3"
                                required={remarksInput.isRequired ? true : false}
                            />
                        </div>
                    }
                    {!(duplicateInput === undefined) &&
                        <div>
                            <Toggle
                                name={duplicateInput.label}
                                enabled={duplicateInput.value}
                                setEnabled={duplicateInput.setValue}
                            />
                        </div>
                    }

                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button
                        name="Enregistrer"
                        disabled={(hourInput.isRequired & !hourInput.value) || (durationInput.isRequired & !durationInput.value)}
                        type={(hourInput.isRequired & !hourInput.value) | (durationInput.isRequired & !durationInput.value) ? "disabled" : ""}
                        action={handleSave}
                        loading={loading}
                    />
                    <Button name="Annuler" type="empty" action={() => setVisible(false)} />
                </div>
            </div>
        </div >
    );

}